<template>
    <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate" @submit.native.prevent="handleSubmit" label-width="120px">
        <FormGroup>名称</FormGroup>
        <el-form-item label="名称" prop="managed_name">
            <el-input v-model.trim="formData.managed_name" placeholder="请输入" :disabled="isView" style="width: 500px;"></el-input>
            <span class="ml20" v-show="!isView">{{formData.managed_name.length}}/100</span>
        </el-form-item>

    </el-form>
</template>

<script>
    import FormGroup from '../formGroup';
    import { validEmoji } from '@/utils/validate'
    export default {
        name: "NameInfo",
        components:{
            FormGroup,
        },
        inject:['validFormItem','isView'],
        data(){
            let validateEmoji = (rule, value, callback)=>{
                if(validEmoji(value)){
                    callback(new Error('不可输入表情'));
                }else{
                    callback();
                }
            };
            let validateName = (rule,value,callback)=>{
                let reg =  /[<>?\/{}”\\|’;#¥%^&*+=]/;
                if(reg.test(value)){
                    callback(new Error('不可携带特殊符号【<>?/{}”\\|’;#¥%^&*+=】'));
                }else if(value.split(' ').length>1){
                    callback(new Error('不可输入空格'));
                }else{
                    callback();
                }
            };

            return {
                formData:{
                    managed_name:'',
                },
                rules:{
                    managed_name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { min: 1, max: 100, message: '最多输入100个字符', trigger: 'blur' },
                        { validator: validateEmoji, trigger: 'blur' },
                        { validator: validateName, trigger: 'blur' },
                    ],
                },
            }
        },
        methods:{
            setFormData(data){
                console.log('setFormData',data);
                this.formData.managed_name = data.managed_name;
            },
            handleValidate(key, valid, info){
                const data = {
                    managed_name: '名称',
                };
                if (!valid) {
                    this.validFormItem(`名称-${data[key]}：${info}`);
                }
            },
            handleSubmit(){
                this.$emit('submit');
            },
            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();
                if (valid) {
                    return {...this.formData}
                }
            },
        },

    }
</script>

<style scoped>

</style>
